import request from '@/utils/request'
import qs from 'qs'
import Vue from 'vue'

export default {
  getPage(query) {
    return request({
      url: Vue.prototype.HOST+'/Action/ExperiencerAction.aspx?action=getPage',
      method: 'post',
      params: query
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/experiencer.js